import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-close-confirmation",
  templateUrl: "./close-confirmation.component.html",
  styleUrls: ["./close-confirmation.component.scss"],
})
export class CloseConfirmationComponent {
  public buttonName = "Continue";
  public hideCancelButton = false;
  constructor(
    public dialogRef: MatDialogRef<CloseConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if(data && data.buttonName){
      this.buttonName = data.buttonName;
    }
    if(data && data.hideCancelButton){
      this.hideCancelButton = data.hideCancelButton;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
